import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型筛选，找到你想看的</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 hover:bg-background-200 rounded-xl p-5 md:p-6 text-center cursor-pointer transition-all duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">{cat.count}部资源</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}